export default function quickSearchInput() {
  $('.quick-search-text').on('click', function () {
    $(this).parents('.search-left-filter').addClass('search-left-filter-open');
    $('.quick-search-drop').fadeIn();
    $('.quick-search-text').fadeOut();
  });
  $('.quick-search-close').on('click', function () {
    $(this).parents('.search-left-filter').removeClass('search-left-filter-open');
    $('.quick-search-drop').fadeOut();
    $('.quick-search-text').fadeIn();
  });
  $('.btn-search-clear').on('click', function () {
    $('.search_phrase').val([]);
    $('.search_phrase').focus();
  });
}